// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FileDownload
 */
export interface FileDownload {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the FileDownload interface.
 */
export function instanceOfFileDownload(value: object): value is FileDownload {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function FileDownloadFromJSON(json: any): FileDownload {
  return FileDownloadFromJSONTyped(json, false);
}

export function FileDownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileDownload {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function FileDownloadToJSON(json: any): FileDownload {
  return FileDownloadToJSONTyped(json, false);
}

export function FileDownloadToJSONTyped(
  value?: FileDownload | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
